import React from 'react'
import { connect } from 'react-redux'
// @ts-ignore no types
import { canUseDom } from '@adc/core-utils/src/helpers/environments'
import config from '@adc/configment'
import type { primitives } from '@adc/blueprint'
import { useListingContext } from 'common/context/listing'
import {
  hooks,
  PhotoGallery as ListingPhotoGallery,
  useApplicationContext,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { withModalHooks } from 'common/hooks/useModalFeatures'
import { getAlternativeItems } from './CustomChiclets'
// @ts-ignore no types
import styles from './index.scss'

const cx = classnames.bind(styles)

interface PhotoGalleryProps {
  isPropertyReportAvailable: boolean
  pushOnboardingQueueItem: (args: any[]) => void
  toggleAuthModal: () => void
}

const PhotoGallery = ({
  isPropertyReportAvailable,
  toggleAuthModal,
  pushOnboardingQueueItem,
}: PhotoGalleryProps) => {
  const { listing } = useListingContext()
  const { featureFlags, user: untypedUser } = useApplicationContext()
  const user = untypedUser as primitives.AuctionUser

  const isMounted = hooks.useIsMounted()
  const alternativeItems = getAlternativeItems({
    featureFlags,
    isPropertyReportAvailable,
    listing,
    pushOnboardingQueueItem,
    toggleAuthModal,
    user,
  })

  return canUseDom() && isMounted ? (
    <div
      className={cx('container')}
      id='photo-gallery'
      data-elm-id='photo-gallery'
    >
      <ListingPhotoGallery
        config={{
          GOOGLE_MAPS_CHANNEL_NAME: config.get('GOOGLE_MAPS_CHANNEL_NAME'),
          GOOGLE_MAPS_API_KEY: config.get('GOOGLE_MAPS_API_KEY'),
          GOOGLE_MAPS_MAP_ID: config.get('GOOGLE_MAPS_MAP_ID', 'DEMO_MAP_ID'),
          LISTING_DEFAULT_PHOTO_URL: config.get(
            'LISTING_DEFAULT_PHOTO_URL',
            ''
          ),
        }}
        alternativeItems={alternativeItems as object[]}
        featureFlags={featureFlags as Record<string, boolean>} // this isn't correct but adding it to fix builds, will need to update listing photo gallery props in ds to remove the need for this
        shouldShowRibbon
        fluid={false}
        listing={listing}
        showMultiple
        displayBanner={false}
      />
    </div>
  ) : null
}

const mapStateToProps = (store: any) => ({
  isPropertyReportAvailable: store.propertyAnalytics.isPropertyReportAvailable,
})

export default connect(mapStateToProps)(withModalHooks(PhotoGallery))
